import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";

const EmptyGroup = {
    localeCode: ' ',
    localeAdminUserId: ' ',
    groupType: ' ',
    name: '',
    enable: 'true',
    unlimitedUse: 'true',
    expiredDate: '',
    expiredDatetime: '',
    maxUserCount: 0,
    timeZone: 0,
    aiPronunciationCount: 1,
    aiTranslationCount: 0,
    aiChatTime: 0,
    defaultEmail: '',
    defaultPassword: '',
    regionApiAddr: 'https://sin-pming.onthe.live',
    skipStep: true,
    logo: ''
};

const logPrefix = "[GroupStore]"
export default class GroupStore {

    constructor(props) {
        this.groupRepository = props.groupRepository;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.groupCount = 0;
        this.groupList = [];

        this.dialogOpen = false;
        this.dialogType = '';

        this.newGroup = Object.assign({}, EmptyGroup);
        this.groupDetail = {};
        this.modifyGroup = {};

        this.localeGroup = [];

        this.initSearch();
        makeAutoObservable(this);
    }

    initLocaleGroup = () => {
        this.localeGroup = [];
    }

    initSearch = () => {
        this.searchType = 'all';
        this.searchText = '';
        this.tempSearchType = 'all';
        this.tempSearchText = '';
        this.sortColumn = '';
        this.isSortAscending = true;
        this.rowsPerPage = 10;
        this.page = 0;
    }

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    }

    setTempSearchType = (type) => {
        this.tempSearchType = type;
        if (type === 'groupType' || type === 'localeCode') {
            this.tempSearchText = 'all';
        } else {
            this.tempSearchText = '';
        }
    }

    setTempSearchText = (text) => {
        this.tempSearchText = text;
    }

    setSearchValue = () => {
        this.searchType = this.tempSearchType;
        this.searchText = this.tempSearchText;
    }

    setSortColumn = (column) => {
        this.sortColumn = column;
    }

    setIsSortAscending = (isAscending) => {
        this.isSortAscending = isAscending;
    }

    setRowsPerPage = (userId, rowsPerPage) => {
        this.rowsPerPage = rowsPerPage;
        this.getGroups(userId);
    }

    setPage = (userId, page) => {
        this.page = page;
        this.getGroups(userId);
    }

    searchGroups = (userId) => {
        this.setSearchValue();
        this.page = 0;
        this.sortColumn = '';
        this.getGroups(userId);
    }

    initNewGroup = () => {
        this.newGroup = Object.assign({}, EmptyGroup);
    }

    setNewGroup = (group) => {
        this.newGroup = group;
    }

    setModifyGroup = (group) => {
        this.modifyGroup = group;
    }

    setDialogOpen = (open, type) => {
        this.dialogOpen = open;
        this.dialogType = type;
    }

    isChangeGroup = () => {
        return JSON.stringify(this.groupDetail) !== JSON.stringify(this.modifyGroup);
    }

    setLocaleGroup = (list) => {
        this.localeGroup = list;
    }

    * getGroups(userId, callback) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getGroups.');
            const url = `?userId=${userId}&searchType=${this.searchType}&searchText=${this.searchText}&rows-per-page=${this.rowsPerPage}&page=${this.page + 1}&sortColumn=${this.sortColumn}&isAscending=${this.isSortAscending}`;
            const response = yield this.groupRepository.getGroups(url);
            this.groupCount = response.data.totalCount;
            this.groupList = response.data.groupList;

            console.log(logPrefix, 'Finished getGroups.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed getGroups.');
            this.openErrorDialog({
                titleText: '그룹 목록 불러오기 오류',
                text: displayErrorDialogPrompt(e, '그룹 목록을 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * addGroup(callback) {
        try {
            console.log(logPrefix, 'Start addGroup.');

            if (this.newGroup.unlimitedUse === 'true') {
                this.newGroup.expiredDatetime = null;
            } else {
                this.newGroup.expiredDatetime = this.newGroup.expiredDate + 'T23:59:59';
            }

            yield this.groupRepository.addGroup(this.newGroup);
            this.newGroup = Object.assign({}, EmptyGroup);

            console.log(logPrefix, 'Finished addGroup.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed addGroup.');
            this.openErrorDialog({
                titleText: '그룹 생성 오류',
                text: displayErrorDialogPrompt(e, '그룹 생성에 실패하였습니다.')
            });
        }
    }

    * updateGroup(groupId, callback) {
        try {
            console.log(logPrefix, 'Start updateGroup.');

            if (this.modifyGroup.unlimitedUse === 'true') {
                this.modifyGroup.expiredDatetime = null;
            } else {
                this.modifyGroup.expiredDatetime = this.modifyGroup.expiredDate + 'T23:59:59';
            }

            yield this.groupRepository.updateGroup(groupId, this.modifyGroup);
            this.modifyGroup = Object.assign({}, EmptyGroup);

            console.log(logPrefix, 'Finished updateGroup.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed updateGroup.');
            this.openErrorDialog({
                titleText: '그룹 수정 오류',
                text: displayErrorDialogPrompt(e, '그룹 수정에 실패하였습니다.')
            });
        }
    }

    * getGroup(groupId, callback) {
        this.groupDetail = {};
        this.modifyGroup = {};
        try {
            console.log(logPrefix, 'Start getGroup.');
            const response = yield this.groupRepository.getGroup(groupId);

            this.groupDetail = response.data;
            this.groupDetail.enable = String(this.groupDetail.enable);
            this.groupDetail.unlimitedUse = this.groupDetail.expiredDatetime === null ? 'true' : 'false';
            this.groupDetail.expiredDate = this.groupDetail.expiredDatetime === null ? '' : this.groupDetail.expiredDatetime.split('T')[0];
            if (this.groupDetail.defaultEmail === null) {
                this.groupDetail.defaultEmail = '';
            }
            if (this.groupDetail.defaultPassword === null) {
                this.groupDetail.defaultPassword = '';
            }
            if (this.groupDetail.logo === null) {
                this.groupDetail.logo = '';
            }

            this.modifyGroup = JSON.parse(JSON.stringify(this.groupDetail));

            console.log(logPrefix, 'Finished getGroup.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed getGroup.');
            this.openErrorDialog({
                titleText: '그룹 정보 불러오기 오류',
                text: displayErrorDialogPrompt(e, '그룹 정보를 불러오는 도중 에러가 발생했습니다.')
            });
        }
    }

    * getLocalGroups(localeCode, callback) {
        try {
            if (localeCode === 'select' || localeCode === '') {
                return;
            }
            console.log(logPrefix, 'Start get Local Groups.');
            const response = yield this.groupRepository.getLocalGroups(localeCode);
            console.log(response)
            this.setLocaleGroup(response.data);
            console.log(logPrefix, 'Finished get Local Groups.');
            console.log("local group", this.localeGroup);
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed get Local Groups.');
        }
    }
}

